import { config as commonConfig } from '@febos-io/common';
import { config as designConfig } from '@febos-io/design';
import { config as authConfig } from '@febos-io/auth';
import { config as healthCommonConfig } from '@febos-io/health-common';

import es from '../i18n/es.json';

designConfig.configureI18n(
  [
    {
      namespace: 'translation',
      bundles: {
        es,
      },
    },
    commonConfig.I18N,
    designConfig.I18N,
    authConfig.I18N,
    healthCommonConfig.I18N
  ]
);
